import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import { formatUsd } from '../lib/profileStepUtils'

interface Props {
  open: boolean
  brandName: string
  amountUsd: number
  onConfirm: () => void
  onCancel: () => void
}

/**
 * TC-12B-56 — Shown when the SP attempts to redeem the same brand + amount
 * within 60 seconds of their last redemption.
 */
export function DuplicateRedemptionDialog({
  open,
  brandName,
  amountUsd,
  onConfirm,
  onCancel,
}: Readonly<Props>) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="duplicate-redemption-title"
      data-testid="rewards-duplicate-dialog"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxWidth: { xs: 'calc(100vw - 32px)', sm: '400px' },
          width: '100%',
          p: 1,
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 2, sm: '24px' }, textAlign: 'center' }}>
        <Typography
          id="duplicate-redemption-title"
          component="h2"
          sx={{ fontSize: '18px', fontWeight: 700, color: '#0d1b2a', mb: 2 }}
        >
          Confirm Duplicate Redemption
        </Typography>

        <Typography sx={{ fontSize: '14px', color: '#475569', mb: 3, lineHeight: 1.6 }}>
          You just redeemed a {brandName} gift card for {formatUsd(amountUsd)}. Are you sure you
          want to redeem another one?
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={onConfirm}
            data-testid="rewards-duplicate-confirm"
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600 }}
          >
            Yes, Redeem
          </Button>
          <Button
            fullWidth
            variant="text"
            onClick={onCancel}
            data-testid="rewards-duplicate-cancel"
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, color: '#64748b' }}
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
